<template>
  <v-container class="my-10">
    <v-row>
      <v-col cols="12" md="12" class="align-self-center">
        <v-card flat>
          <v-card-text>
            <v-row justify="center" class="black--text">
              <v-col cols="12" md="12">
                <div class="mb-5">
                  <h2 class="text-md-h4 font-weight-bold sub-title-page">
                    Penerimaan Jalur {{ djalur.nama }}
                  </h2>
                </div>
                <div class="my-8">
                  <v-tabs
                    v-model="tabdata">
                    <v-tab
                      href="#tabd-desc"
                      class="text-capitalize font-weight-black">
                      Deskripsi
                    </v-tab>
                    <v-tab
                      href="#tabd-kriteria"
                      class="text-capitalize font-weight-black">
                      Kriteria
                    </v-tab>
                    <v-tab
                      href="#tabd-afirmasi"
                      class="text-capitalize font-weight-black">
                      Afirmasi
                    </v-tab>
                    <v-tab
                      href="#tabd-iuran"
                      class="text-capitalize font-weight-black">
                      Iuran Pengembangan
                    </v-tab>
                    <v-tab
                      href="#tabd-digital"
                      class="text-capitalize font-weight-black">
                      Digitalisasi
                    </v-tab>
                    <v-tab
                      href="#tabd-kelulusan"
                      class="text-capitalize font-weight-black">
                      Penentun Kelulusan
                    </v-tab>
                    <v-tab
                      href="#tabd-pengaduan"
                      class="text-capitalize font-weight-black">
                      Pengaduan
                    </v-tab>
                    <v-tab-item value="tabd-desc">
                      <v-card flat>
                        <v-card-text>
                          Deskripsi Jalur
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tabd-kriteria">
                      <v-card flat>
                        <v-card-text>
                          <p>
                            Penentuan kelulusan penerimaan mahasiswa baru Jalur Mandiri dengan menggunakan Ujian Mandiri Bersama Politeknik Negeri secara hybrid, kombinasi Ujian Tulis Berbasis Komputer (UTBK) dan Ujian Tulis Manual menggunakan Lembar Jawab Komputer (LJK).
                          </p>
                          <p>
                            UTBK digelar dengan memaksimalkan sarana dan prasarana yang tersedia di Kampus Politeknik Negeri Bali. Memanfaatkan sebanyak 12 ruang laboratorium komputer dengan total kapasitas maksimum sebanyak 250 komputer.
                          </p>
                          <p>
                            Ujian Tulis Manual digelar dengan memanfaatkan ruang kuliah dengan kapasitas 30 peserta tes di setiap ruangan.
                          </p>
                          <p>
                            UTBK dan Ujian Tulis Manual diselenggarakan dalam 2 sesi, yaitu sesi pagi pukul 09:00-11:30 wita dan sesi siang pukul 13:00-15:30 wita. Baik UTBK dan Ujian Tulis Manual menggunakan soal ujian khusus yang disusun oleh tim pembuat soal Politeknik Negeri Bali. Dengan jumlah soal sebanyak 100 soal meliputi:
                            <ul>
                              <li>Potensi kognitif/skolastis = 25 soal</li>
                              <li>Penalaran matematika = 35 soal</li>
                              <li>Literasi dalam bahasa Indonesia = 20 soal</li>
                              <li>Literasi dalam bahasa Inggris = 20 soal.</li>
                            </ul>
                          </p>
                          <p>Sistem skoring:
                            <ul>
                              <li>Benar = 4</li>
                              <li>Salah = -1</li>
                              <li>Kosong = 0</li>
                            </ul>
                          </p>
                          <p>
                            Kelulusan ditentukan berdasarkan hasil pemeringkatan dan kuota masing-masing prodi.
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tabd-afirmasi">
                      <v-card flat>
                        <v-card-text>
                          <p>
                            Kebijakan Afirmasi diterapkan dalam penerimaan mahasiswa baru Jalur Mandiri Politeknik Negeri Bali. Dengan memperhatikan kondisi ekonomi peserta tes berdasarkan identifikasi pendaftar Kartu Indonesia Pintar Kuliah (KIP-Kuliah). Kartu Indonesia Pintar Kuliah (KIP-Kuliah) adalah salah satu upaya untuk membantu asa para siswa yang memiliki keterbatasan ekonomi tetapi berprestasi untuk melanjutkan studi di perguruan tinggi.
                          </p>
                          <p>
                            Kebijakan Afirmasi juga diterapkan kepada siswa lokal di wilayah tertentu dengan adanya Program Studi di luar Kampus Utama (PSDKU) yang memungkinkan siswa memilih program studi sesuai dengan domisilinya. Pada program studi PSDKU juga berlaku beasiswa dari pemerintah daerah setempat. Penyelenggaran program studi PSDKU didukung pula oleh pemerintah daerah setempat dengan memfasilitasi gedung kuliah.
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tabd-iuran">
                      <v-card flat>
                        <v-card-text>
                          <p>
                            Iuran pengembangan institusi
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tabd-digital">
                      <v-card flat>
                        <v-card-text>
                          <p>
                            Pada penerimaan mahasiswa baru Jalur Mandiri Politeknik Negeri Bali memaksimalkan digitalisasi pada tiap prosesnya. Mulai dari proses pendaftaran dilakukan secara online melalui Sistem Informasi Online PNB (SION), pembayaran biaya pendaftaran dilakukan secara online, hingga pelaksanaan ujian masuk yang dilakukan secara hybrid dengan UTBK dan Ujian Tulis Manual.
                          </p>
                          <p>
                            UTBK digelar dengan memaksimalkan sarana dan prasarana yang tersedia di Kampus Politeknik Negeri Bali. Memanfaatkan sebanyak 12 ruang laboratorium komputer dengan total kapasitas maksimum sebanyak 250 komputer.
                          </p>
                          <p>
                            Digitalisasi juga diterapkan pada proses penentuan UKT, proses pengisian form Iuran Pengembangan Institusi, dan proses Pendaftaran Kembali Calon Mahasiswa Baru Politeknik Negeri Bali.
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tabd-kelulusan">
                      <v-card flat>
                        <v-card-text>
                          <p>
                            Setelah melalui proses pemeringkatan dan berbagai pertimbangan termasuk kuota daya tampung masing-masing program studi, penentuan kelulusan penerimaan mahasiswa baru Jalur Mandiri dilakukan secara rapat pleno bersama panitia Penerimaan Mahasiswa Baru.
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tabd-pengaduan">
                      <v-card flat>
                        <v-card-text>
                          <p>
                            Pengaduan PMB
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </div>
                <div>
                  <v-divider></v-divider>
                </div>
                <div class="mb-3">
                  <div class="foot-list-content">
                    <strong class="text-subtitle-1">
                      Informasi Pengaduan Penerimaan Mahasiswa Baru:
                      <router-link :to="{ name: 'Pengaduanpmb' }">
                        Pengaduan
                      </router-link>
                    </strong>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Jalurpenerimaan',
  props: ['slug'],
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      contact: false,
      regnew: false,
    },
    api: process.env.VUE_APP_API,
    apptitle: process.env.VUE_APP_TITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    publickey: '123',
    contact: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    datakuota: [
      {
        kdprodi: '617001',
        prodi: 'MANAJEMEN PROYEK KONSTRUKSI',
        total: '150',
        snbp: '38',
        psnbp: '25,33 %',
        snbt: '68',
        psnbt: '45,33 %',
        mandiri: '44',
        pmandiri: '29,33 %',
      },
      {
        kdprodi: '617002',
        prodi: 'TEKNOLOGI REKAYASA UTILITAS',
        total: '60',
        snbp: '15',
        psnbp: '25,00 %',
        snbt: '27',
        psnbt: '45,00 %',
        mandiri: '18',
        pmandiri: '30,00 %',
      },
      {
        kdprodi: '617003',
        prodi: 'TEKNIK OTOMASI',
        total: '90',
        snbp: '23',
        psnbp: '25,56 %',
        snbt: '41',
        psnbt: '45,56 %',
        mandiri: '26',
        pmandiri: '28,89 %',
      },
    ],
    word: 'Vue',
    dmodal: {
      register: false,
    },
    regflag: false,
    djalur: {
      nama: '',
      kriteria: '',
      afirmasi: '',
      kuota: '',
      ipi: '',
      digital: '',
      kelulusan: '',
      pengaduan: '',
      desc: '',
    },
    tabdata: null,
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  mounted() {
    if (this.slug) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      switch (this.slug) {
        case 'mandiri':
          this.djalur.nama = 'Mandiri';
          break;
        case 'snbp':
          this.djalur.nama = 'Seleksi Nasional Berdasarkan Prestasi';
          break;
        case 'snbt':
          this.djalur.nama = 'Seleksi Nasional Berdasarkan Tes';
          break;
        case 'alih-jenjang':
          this.djalur.nama = 'Alih Jenjang';
          break;
        case 'd2-fast-track':
          this.djalur.nama = 'D2 Fast Track';
          break;
        case 'kerjasama':
          this.djalur.nama = 'Kerjasaa';
          break;
        case 'pasca-sarjana':
          this.djalur.nama = 'Pasca Sarjana';
          break;
        default:
          this.djalur.nama = 'Mandiri';
          break;
      }
    },
    submitContact() {
      this.alertdata.show = false;
      if (this.$refs.formcontact.validate()) {
        this.loading.contact = true;
        this.axios
          .post(
            this.api + '/public/contact',
            qs.stringify(
              this.contact,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            this.alertdata.show = true;
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data === 1) {
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Thank you for getting in touch!';
                } else {
                  this.alertdata.type = 'error';
                  this.alertdata.text = 'Sorry we get error in your sending email, please try again!';
                }
              } else {
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.contact = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.contact = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
